import { createAction } from 'redux-act';

/** Данные для префилла формы замены актива (fromIsin, toIsin при открытии из контекста). */
export interface ConvertTradeFormPrefill {
  fromIsin?: string;
  toIsin?: string;
  [key: string]: unknown;
}

export const setConvertTradeModalVisible = createAction<boolean>('SET_CONVERT_TRADE_MODAL_VISIBLE');
export const setConvertTradeForm = createAction<ConvertTradeFormPrefill | null>(
  'SET_CONVERT_TRADE_FORM'
);
